// Joins class names, skipping the falsy ones: shadcn's cn() without
// tailwind-merge, since no class here overrides another's utilities.
export function cn(...parts: (string | false | null | undefined)[]) {
  return parts.filter(Boolean).join(" ");
}
